import TransportA2Header from "./Header";
import "./index.css";
import TransportToManufacturing from "./TransportToManufacturing";
import SurplusMaterials from "./SurplusMaterials";
import LossesA2 from "./Losses";
import { ShowHide } from "../components/ShowHideProduct";
import { usePDFShowHide } from "../../../../hooks/usePDFShowHide";

const TransportA2Components = ({ productId }) => {
  const [show, setShow] = usePDFShowHide(false, {
    forceShowInPDF: true,
    pdfDelay: 1000,
  });

  return (
    <div className="transport-a2-container" id="transport-a2-id">
      <TransportA2Header productId={productId} show={show} />
      <ShowHide show={show} setShow={setShow} />
      {show && <TransportToManufacturing productId={productId} />}
      {show && <SurplusMaterials productId={productId} />}
      {show && <LossesA2 productId={productId} />}
    </div>
  );
};

export default TransportA2Components;
